import React from 'react'
import PropTypes from 'prop-types'

import { Content } from './styles'

function Span(props) {
  return <Content {...props} />
}

Span.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  font: PropTypes.string,
  color: PropTypes.string,
}

export default Span
